<template>
  <div class="widget">
    <div v-loading="$mip('getUsers')" class="widget__body">
      <div v-for="(user, index) in users" :key="user.id">
        <div class="row flex-y-center">
          <div class="col-md-3 h3">
            {{ user.name }}
          </div>
          <div class="col-md-3">
            Логин: {{ user.login }}
          </div>
          <div class="col-md-5">
            <span v-if="user.isAdmin" class="text-medium">Администратор</span>
            <span v-if="!user.isAdmin" class="user-title">Пользователь</span>
            <span v-if="!user.isAdmin && user.hasAccountAccess" class="user-title">Доступ в ЛК</span>
          </div>
          <div v-if="$store.state.user.accInfo.isAdmin" class="col-md-1">
            <div class="edit-btn ml-auto" @click="handleEditUser(user.id)">
              <span class="icon icon-sm" v-html="require('@/assets/img/icons/edit.svg')" />
            </div>
          </div>
        </div>
        <div v-if="index !== users.length - 1" class="divider" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      users: Array
    },

    methods: {
      handleEditUser(userId) {
        this.$emit('edit-user', userId)
      }
    }
  }
</script>

<style>
  .user-title {
    margin-right: 6px;
  }

  .user-title:after {
    content: ',';
    display: inline-block;
  }

  .user-title:last-child::after {
    display: none;
  }
</style>